const translations = {
	page_title: "Souscription {{productName}} de {{civility}} {{subscriberName}}",
	sub_pages: {
		subscribers: {
			page_title: "Souscripteur(s)",
			corporationInfo: "Informations société",
			legal_representative: "Représentant légal",
			beneficiary: "Bénéficiaire effectif",
		},
		payment: {
			page_title: "Mode de règlement",
		},
		bulletin: {
			page_title: "Bulletin de souscription",
		},
		files: {
			page_title: "Pièces justificatives",
		},
	},
};

export default translations;
